export const globalGetters = {
  deficiencyTypes: 'deficiencyType/deficiencyTypes'
}

export const getters = {
  deficiencyTypes: state => state.deficiencyTypes
}
